// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staking_dashboard_container {
    width: 100%;
    /* padding: 20px; */
    /* background-color: var(--background-color); */
}

.staking_dashboard_grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    max-width: 1400px;
    margin: 0 auto;
}

/* Chart Section */
.staking_chart_section {
    background-color: var(--card-background-color);
    border: 1px solid black;
    /* padding: 20px; */
    height: 100%;
}

.section_title {
    text-align: center;
    /* margin-bottom: 1.5rem; */
    font-family: 'Roboto Mono', monospace;
    font-size: 1.25rem;
    font-weight: 400;
}

/* Cards Section */
.staking_cards_section {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.staking_card {
    background-color: var(--card-background-color);
    border: 1px solid black;
    padding: 20px;
    transition: transform 0.2s ease;
}

.staking_card:hover {
    transform: translateY(-2px);
}

/* ASXN Labs Card */
.asxn_card {
    background-color: var(--primary-color);
    color: white;
}

.asxn_card h4 {
    font-size: 18px;
    margin: 0 0 10px 0;
}

.coming_soon {
    font-size: 14px;
    opacity: 0.8;
}

/* Card Content */
.card_label {
    font-size: 14px;
    color: var(--text-color);
    margin-bottom: 8px;
}

.card_value {
    font-size: 24px;
    font-weight: bold;
    color: var(--primary-color);
}

/* Tooltip */
.staking_tooltip {
    background-color: var(--card-background-color);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    padding: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tooltip_date {
    font-size: 12px;
    color: var(--text-color);
    margin: 0;
    font-weight: bold;
}

.tooltip_value {
    font-size: 12px;
    color: var(--primary-color);
    margin: 4px 0 0 0;
}

/* Loading and Error States */
.staking_metrics_loader,
.staking_metrics_error {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    font-size: 16px;
    color: var(--text-color);
}

/* Responsive Design */
@media screen and (max-width: 1024px) {
    .staking_dashboard_grid {
        grid-template-columns: 1fr;
    }

    .staking_chart_section {
        height: 500px;
    }
}

@media screen and (max-width: 768px) {
    .staking_dashboard_container {
        padding: 10px;
    }

    .staking_chart_section {
        height: 400px;
        padding: 15px;
    }

    .staking_card {
        padding: 15px;
    }

    .card_value {
        font-size: 20px;
    }
}

@media screen and (max-width: 480px) {
    .staking_dashboard_container {
        padding: 5px;
    }

    .section_title {
        font-size: 14px;
    }

    .card_label {
        font-size: 12px;
    }

    .card_value {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/hype_staking/staking_dasboard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,8CAA8C;IAC9C,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,8CAA8C;IAC9C,uBAAuB;IACvB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,mBAAmB;AACnB;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".staking_dashboard_container {\n    width: 100%;\n    /* padding: 20px; */\n    /* background-color: var(--background-color); */\n}\n\n.staking_dashboard_grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 20px;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n/* Chart Section */\n.staking_chart_section {\n    background-color: var(--card-background-color);\n    border: 1px solid black;\n    /* padding: 20px; */\n    height: 100%;\n}\n\n.section_title {\n    text-align: center;\n    /* margin-bottom: 1.5rem; */\n    font-family: 'Roboto Mono', monospace;\n    font-size: 1.25rem;\n    font-weight: 400;\n}\n\n/* Cards Section */\n.staking_cards_section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.staking_card {\n    background-color: var(--card-background-color);\n    border: 1px solid black;\n    padding: 20px;\n    transition: transform 0.2s ease;\n}\n\n.staking_card:hover {\n    transform: translateY(-2px);\n}\n\n/* ASXN Labs Card */\n.asxn_card {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n.asxn_card h4 {\n    font-size: 18px;\n    margin: 0 0 10px 0;\n}\n\n.coming_soon {\n    font-size: 14px;\n    opacity: 0.8;\n}\n\n/* Card Content */\n.card_label {\n    font-size: 14px;\n    color: var(--text-color);\n    margin-bottom: 8px;\n}\n\n.card_value {\n    font-size: 24px;\n    font-weight: bold;\n    color: var(--primary-color);\n}\n\n/* Tooltip */\n.staking_tooltip {\n    background-color: var(--card-background-color);\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    padding: 12px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tooltip_date {\n    font-size: 12px;\n    color: var(--text-color);\n    margin: 0;\n    font-weight: bold;\n}\n\n.tooltip_value {\n    font-size: 12px;\n    color: var(--primary-color);\n    margin: 4px 0 0 0;\n}\n\n/* Loading and Error States */\n.staking_metrics_loader,\n.staking_metrics_error {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 400px;\n    font-size: 16px;\n    color: var(--text-color);\n}\n\n/* Responsive Design */\n@media screen and (max-width: 1024px) {\n    .staking_dashboard_grid {\n        grid-template-columns: 1fr;\n    }\n\n    .staking_chart_section {\n        height: 500px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .staking_dashboard_container {\n        padding: 10px;\n    }\n\n    .staking_chart_section {\n        height: 400px;\n        padding: 15px;\n    }\n\n    .staking_card {\n        padding: 15px;\n    }\n\n    .card_value {\n        font-size: 20px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .staking_dashboard_container {\n        padding: 5px;\n    }\n\n    .section_title {\n        font-size: 14px;\n    }\n\n    .card_label {\n        font-size: 12px;\n    }\n\n    .card_value {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
